import { ValidatorArrivalMatchDepartureSameRecordProps } from "../../../../../models/add"
import { setNameRowDetail } from "../../setNameRowDetail"
import { Translate } from "../../../../../../../../constant/Translate"

const { MESSAGE_E0160 } = Translate

export const validatorArrivalMatchDepartureSameRecord = ({
  getFieldValue,
  index,
}: ValidatorArrivalMatchDepartureSameRecordProps) => ({
  // eslint-disable-next-line complexity, max-statements
  validator() {
    const itemName = setNameRowDetail(index)
    const arrivalCityCode = getFieldValue(`${itemName}.arrivalCityCode`)
    const arrivalCityName = getFieldValue(`${itemName}.arrivalCityName`)
    const arrivalCountryCode = getFieldValue(`${itemName}.arrivalCountryCode`)
    const departureCityCode = getFieldValue(`${itemName}.departureCityCode`)
    const departureCityName = getFieldValue(`${itemName}.departureCityName`)
    const departureCountryCode = getFieldValue(
      `${itemName}.departureCountryCode`,
    )

    const isSameArrivalDepartureInRow =
      arrivalCountryCode === departureCountryCode &&
      arrivalCityCode === departureCityCode &&
      (arrivalCityName || "") === (departureCityName || "")

    if (isSameArrivalDepartureInRow) {
      return Promise.reject(new Error(MESSAGE_E0160))
    }
    return Promise.resolve()
  },
})
